module.exports = __webpack_public_path__ + "static/media/Lato-Thin.fe4e34a5.eot";